import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE_CONTRIBUTOR_LIST = {
  'loading': false,
  'contributorTypesList': [],
  'contTypesListCed': [],
  'contTypesListRuc': [],
  'contTypesListPass': [],
  'provinces': [],
  'clientTypes': [],
  'cities': [],
};

export const extraData = (state, action) => {
  return createReducer(INITIAL_STATE_CONTRIBUTOR_LIST, {
    [ActionTypes.FETCHING_CONTRIBUTOR_TYPES]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_CONTRIBUTOR_TYPES]: (state, action) => {
      return {
        ...state,
        'loading': false,
        'contributorTypesList': action.response.data,
        'contTypesListCed': action.response.data.filter((element) =>
          ['P'].includes(element.code)),
        'contTypesListRuc': action.response.data.filter((element) =>
          ['E', 'F', 'N', 'R', 'T'].includes(element.code)),
        'contTypesListPass': action.response.data.filter((element) =>
          ['3', '4'].includes(element.code)),
      };
    },
    [ActionTypes.FETCHED_CONTRIBUTOR_TYPES_FAILED]: (state) => {
      return {
        ...state,
        'loading': false,
        'contributorTypesList': [],
      };
    },

    [ActionTypes.FETCHING_PROVINCES]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_PROVINCES]: (state, action) => {
      return {
        ...state,
        'loading': false,
        'provinces': action.response.data,
      };
    },
    [ActionTypes.FETCHED_PROVINCES_FAILED]: (state) => {
      return {
        ...state,
        'loading': false,
        'provinces': [],
      };
    },

    [ActionTypes.FETCHING_CITIES_CODES]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_CITIES_CODES]: (state, action) => {
      return {
        ...state,
        'loading': false,
        'cities': action.response.data,
      };
    },
    [ActionTypes.FETCHED_CITIES_CODES_FAILED]: (state) => {
      return {
        ...state,
        'loading': false,
        'cities': [],
      };
    },

    [ActionTypes.FETCHING_CLIENT_TYPES]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_CLIENT_TYPES]: (state, action) => {
      return {
        ...state,
        'loading': false,
        'clientTypes': action.response.data,
      };
    },
    [ActionTypes.FETCHED_CLIENT_TYPES_FAILED]: (state) => {
      return {
        ...state,
        'loading': false,
        'clientTypes': [],
      };
    },
  })(state, action);
};
